(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.style-set');
    if (!root) return;

    var typeButtons = root.querySelectorAll('[data-style-set-type]');
    var colorButtons = root.querySelectorAll('[data-style-set-color]');
    var variantInput = document.getElementById('StyleSetVariantId');
    var submitButton = root.querySelector('.style-set__cta');
    var soldOutMessage = submitButton ? submitButton.querySelector('.sold-out-message') : null;
    var submitButtonText = submitButton ? submitButton.querySelector('span') : null;
    var kiltImage = document.getElementById('StyleSetKiltImage');
    var laceImage = document.getElementById('StyleSetLaceImage');

    var state = { type: 'a', color: 'white-blue' };

    // Combo data comes from hidden data-* elements, not a JSON blob, so one
    // bad Liquid value can never throw during parsing and take every click
    // handler down with it.
    var combos = [];
    try {
      var comboEls = document.querySelectorAll('.style-set__combo-data');
      combos = Array.prototype.map.call(comboEls, function (el) {
        return {
          type: el.getAttribute('data-type'),
          color: el.getAttribute('data-color'),
          variantId: el.getAttribute('data-variant-id'),
          available: el.getAttribute('data-available') === 'true',
          kiltImage: el.getAttribute('data-kilt-image'),
          kiltAlt: el.getAttribute('data-kilt-alt'),
          laceImage: el.getAttribute('data-lace-image'),
        };
      });
    } catch (e) {
      combos = [];
    }

    function findCombo(type, color) {
      for (var i = 0; i < combos.length; i++) {
        if (combos[i].type === type && combos[i].color === color) return combos[i];
      }
      return null;
    }

    function setPressed(buttons, matchFn) {
      buttons.forEach(function (button) {
        var isMatch = matchFn(button);
        button.classList.toggle('is-selected', isMatch);
        button.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      });
    }

    function render() {
      // Combinations stay selectable even when sold out: only the CTA is
      // blocked. The color grid just labels which combination is currently
      // unavailable.
      colorButtons.forEach(function (button) {
        var color = button.getAttribute('data-style-set-color');
        var combo = findCombo(state.type, color);
        var statusEl = button.querySelector('.style-set__color-status');
        var available = !!(combo && combo.available);
        button.classList.toggle('is-sold-out', !available);
        if (statusEl) statusEl.textContent = available ? '' : 'SOLD OUT';
      });

      setPressed(typeButtons, function (b) {
        return b.getAttribute('data-style-set-type') === state.type;
      });
      setPressed(colorButtons, function (b) {
        return b.getAttribute('data-style-set-color') === state.color;
      });

      var combo = findCombo(state.type, state.color);
      if (!combo) return;

      if (variantInput) variantInput.value = combo.variantId;
      if (kiltImage && combo.kiltImage) {
        kiltImage.src = combo.kiltImage;
        kiltImage.alt = combo.kiltAlt || kiltImage.alt;
      }
      if (laceImage && combo.laceImage) laceImage.src = combo.laceImage;

      if (submitButton) {
        var disabled = !combo.available;
        submitButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        submitButton.disabled = disabled;
        if (soldOutMessage && submitButtonText) {
          soldOutMessage.classList.toggle('hidden', !disabled);
          submitButtonText.classList.toggle('hidden', disabled);
        }
      }
    }

    // Click handlers are bound unconditionally, before anything else, so
    // TYPE/COLOR selection always works even if combo data were empty.
    typeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.type = button.getAttribute('data-style-set-type');
        render();
      });
    });

    colorButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.color = button.getAttribute('data-style-set-color');
        render();
      });
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
